const debug = process.env.REACT_APP_DEBUG && false;
/** revised version for combo based LineBarChart */
export const historyObjectToDataTable = (historyObject, keys, slice) => {
    const dataTable = new google.visualization.DataTable();
    dataTable.addColumn('datetime', 'Time'); // x
    const existingKeys = keys.filter((key) => historyObject[key]);
    existingKeys.forEach((k, columnIdx) => {
        const type = k === 'timestamp' ? 'datetime' : 'number';
        dataTable.addColumn(type, k); // yi
    });
    const invalidColumnIndexes = [];
    historyObject.timestamp.forEach((ts, idx) => {
        if (!slice || (idx >= slice[0] && idx <= slice[1])) {
            const rowData = [];
            const convertedDate = new Date(ts);
            rowData.push(convertedDate);
            existingKeys.forEach((k, columnIdx) => {
                const keyArray = historyObject[k];
                if (keyArray) {
                    const data = keyArray[idx];
                    if (isNaN(data)) {
                        /** options uses interpolateNulls so trusting the chart to do what previously resulted in zero starting lines */
                        debug && console.log(`We knowingly pushed ${data} onto ${k}: ${idx} `);
                    }
                    rowData.push(data);
                }
                else {
                    debug && console.log(`No key array ${k} on `, historyObject);
                }
            });
            dataTable.addRow(rowData);
        }
        else {
            debug && console.log('historyObjectToDataTable not adding row', { slice, idx });
        }
    });
    debug && console.log('invalidColumns', invalidColumnIndexes);
    debug && console.log('dataTable', dataTable);
    return dataTable;
};
